import { render, staticRenderFns } from "./OrderError.vue?vue&type=template&id=18cfcf51"
import script from "./OrderError.vue?vue&type=script&lang=js"
export * from "./OrderError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports